import React from 'react';
import { BrowserSizeProvider } from './BrowserSize';
import { NetworkRoleProvider } from './NetworkRole';
import { UnsavedChangesWarningProvider } from './UnsavedChangesWarning';
import { FeatureFlagsProvider } from './FeatureFlags';

export function AppProviders({ children }: { children: JSX.Element }) {
  return (
    <FeatureFlagsProvider>
      <UnsavedChangesWarningProvider>
        <NetworkRoleProvider>
          <BrowserSizeProvider>{children}</BrowserSizeProvider>
        </NetworkRoleProvider>
      </UnsavedChangesWarningProvider>
    </FeatureFlagsProvider>
  );
}
